import { Toaster } from "react-hot-toast";
import { baseToastClassName } from "@/components/providers/toastStyles";

export function HotToaster() {
  return (
    <Toaster
      position="top-right"
      containerStyle={{ zIndex: 99999 }}
      toastOptions={{
        duration: 4000,
        className: `${baseToastClassName} border-line bg-bg-card text-ink-primary`,
        success: {
          className: `${baseToastClassName} border-brand-emerald/40 bg-brand-emerald/10 text-ink-primary`,
        },
        error: {
          className: `${baseToastClassName} border-state-danger/40 bg-state-danger/10 text-ink-primary`,
        },
      }}
    />
  );
}
